export enum EcertDisplayType {
    Dollars = 0,
    Points = 1,
}

export interface IEcertBalanceInfo {
    ecertCode: string;
    availableBalance: number;
    ecertId: number;
    displayType: EcertDisplayType;
    dollarValuePerPoint: number | null;
}
